(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["roro-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  /**
   * Drag-to-scroll del carrusel de colecciones.
   *
   * Solo ratón: en táctil manda el scroll nativo del navegador, que ya trae
   * inercia y respeta el scroll-snap. Mismo umbral (4px) y misma supresión del
   * click que `assets/roro-product-carousel.js`, para que arrastrar el carrusel
   * de colecciones y el de productos se sienta idéntico.
   */
  (function () {
    var ROOT_SELECTOR = '[data-cc-root]';

    function initRoot(root) {
      if (root.dataset.ccReady === 'true') return;
      root.dataset.ccReady = 'true';

      if (root.dataset.ccDrag !== 'true') return;

      var track = root.querySelector('[data-cc-track]');
      if (!track) return;

      var down = false;
      var moved = false;
      var suppressClick = false;
      var startX = 0;
      var startScroll = 0;

      track.classList.add('is-draggable');

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        down = true;
        moved = false;
        suppressClick = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      });

      window.addEventListener(
        'pointermove',
        function (event) {
          if (!down) return;

          var dx = event.clientX - startX;
          if (!moved && Math.abs(dx) > 4) {
            moved = true;
            track.classList.add('is-dragging');
          }
          if (!moved) return;

          event.preventDefault();
          track.scrollLeft = startScroll - dx;
        },
        { passive: false }
      );

      function endDrag() {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        if (moved) suppressClick = true;
      }

      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      // Evita el drag nativo de imágenes y enlaces del navegador.
      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      // Un arrastre no debe abrir la colección. Fase de captura para llegar
      // antes que la navegación del enlace.
      track.addEventListener(
        'click',
        function (event) {
          if (!suppressClick) return;
          suppressClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    }

    function initAll(scope) {
      if (!scope || typeof scope.querySelectorAll !== 'function') return;
      if (scope.matches && scope.matches(ROOT_SELECTOR)) initRoot(scope);
      scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    // El theme editor monta y desmonta la sección sin recargar la página.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roro-scatter-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT_SELECTOR = '[data-rsg-root]';

    function initRoot(root) {
      if (root.dataset.rsgReady === 'true') return;
      root.dataset.rsgReady = 'true';

      if (root.dataset.rsgDrag !== 'true') return;

      var track = root.querySelector('[data-rsg-track]');
      if (!track) return;

      var down = false;
      var moved = false;
      var startX = 0;
      var startScroll = 0;

      track.classList.add('is-draggable');

      track.addEventListener('pointerdown', function (event) {
        // Solo ratón: en táctil manda el scroll nativo.
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        down = true;
        moved = false;
        startX = event.clientX;
        startScroll = track.scrollLeft;
      });

      window.addEventListener(
        'pointermove',
        function (event) {
          if (!down) return;

          var dx = event.clientX - startX;
          if (!moved && Math.abs(dx) > 4) {
            moved = true;
            track.classList.add('is-dragging');
          }
          if (!moved) return;

          event.preventDefault();
          track.scrollLeft = startScroll - dx;
        },
        { passive: false }
      );

      function endDrag() {
        if (!down) return;
        down = false;
        moved = false;
        track.classList.remove('is-dragging');
      }

      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
    }

    function initAll(scope) {
      if (!scope || typeof scope.querySelectorAll !== 'function') return;
      if (scope.matches && scope.matches(ROOT_SELECTOR)) initRoot(scope);
      scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    // El editor de temas vuelve a pintar la sección al cambiar un ajuste.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roro-social-proof"] && !Shopify.designMode) return;
  try {
    
  /**
   * Botón "+" del mosaico de social proof: revela las filas que en móvil quedan
   * recortadas. Delegado en document porque la sección puede montarse y
   * desmontarse desde el theme editor sin volver a ejecutar este archivo.
   */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-roro-sp-more]');
    if (!button) return;

    var root = button.closest('[data-roro-sp]');
    if (!root) return;

    root.classList.add('is-expanded');
    button.hidden = true;

    // El botón desaparece: si no se mueve el foco, se pierde en el body.
    var revealed = root.querySelector('.roro-sp__item--over-rows .roro-sp__tile');
    if (revealed && typeof revealed.focus === 'function') {
      revealed.focus({ preventScroll: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roro-video-collage"] && !Shopify.designMode) return;
  try {
    
  /* Video Collage: carga perezosa, pausa fuera de pantalla, pausa y sonido
     por vídeo, reduced-motion. Vanilla y un solo componente (CLAUDE.md). */
  (() => {
    if (customElements.get('roro-video-collage')) return;

    class RoroVideoCollage extends HTMLElement {
      connectedCallback() {
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.small = window.matchMedia('(max-width: 989px)');
        this.clips = [...this.querySelectorAll('[data-rvc-clip]')]
          .map((el) => ({
            el,
            video: el.querySelector('video'),
            pauseBtn: el.querySelector('[data-rvc-pause]'),
            soundBtn: el.querySelector('[data-rvc-sound]'),
            userPaused: false,
            visible: false,
          }))
          .filter((clip) => clip.video);

        if (!this.clips.length) return;

        this.clips.forEach((clip) => {
          if (this.reduce) this.setPaused(clip, true);

          clip.video.addEventListener('playing', () => clip.el.classList.add('is-ready'));

          clip.video.addEventListener('error', () => {
            const { srcFull } = clip.video.dataset;
            if (!srcFull || clip.video.getAttribute('src') === srcFull) return;
            clip.video.src = srcFull;
            if (clip.visible && !clip.userPaused) this.play(clip);
          });

          clip.pauseBtn.addEventListener('click', () => {
            this.setPaused(clip, !clip.userPaused);
            if (clip.userPaused) clip.video.pause();
            else this.play(clip);
          });

          clip.soundBtn.addEventListener('click', () => {
            const turnOn = clip.video.muted;
            this.clips.forEach((other) => this.setSound(other, false));
            this.setSound(clip, turnOn);
            if (turnOn && clip.video.paused) {
              this.setPaused(clip, false);
              this.play(clip);
            }
          });
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const clip = this.clips.find((c) => c.el === entry.target);
              if (!clip) return;
              clip.visible = entry.isIntersecting;
              if (clip.visible && !clip.userPaused) this.play(clip);
              if (!clip.visible) clip.video.pause();
            });
          },
          { threshold: 0.3 }
        );
        this.clips.forEach((clip) => this.observer.observe(clip.el));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      load(clip) {
        if (clip.video.dataset.loaded) return;
        const { srcSd, srcHd } = clip.video.dataset;
        clip.video.src = this.small.matches ? srcSd : srcHd || srcSd;
        clip.video.dataset.loaded = 'true';
      }

      play(clip) {
        this.load(clip);
        const attempt = clip.video.play();
        if (attempt) attempt.catch(() => {});
      }

      setPaused(clip, paused) {
        clip.userPaused = paused;
        clip.pauseBtn.setAttribute('aria-pressed', String(paused));
        clip.el.classList.toggle('is-paused', paused);
      }

      setSound(clip, on) {
        clip.video.muted = !on;
        clip.soundBtn.setAttribute('aria-pressed', String(on));
        clip.el.classList.toggle('is-sound', on);
      }
    }

    customElements.define('roro-video-collage', RoroVideoCollage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roro-video-feature"] && !Shopify.designMode) return;
  try {
    
  /* Video Feature — pausa fuera de pantalla, sonido y reduced-motion.
     Vanilla, sin build step, un componente por archivo (CLAUDE.md). Va en el
     bloque de javascript de la seccion y no en `assets/` porque son 60 lineas
     que solo tienen sentido con este marcado; si crece, se saca. */
  (function () {
    'use strict';

    function initRoot(root) {
      if (root.dataset.rvfInit === 'true') return;
      root.dataset.rvfInit = 'true';

      var video = root.querySelector('[data-rvf-video]');
      if (!video) return;

      var soundBtn = root.querySelector('[data-rvf-sound]');
      var playBtn = root.querySelector('[data-rvf-play]');
      var iconMuted = root.querySelector('[data-rvf-icon-muted]');
      var iconLoud = root.querySelector('[data-rvf-icon-loud]');

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Un autoplay siempre arranca mudo: es la condicion que ponen los
      // navegadores. Sin boton de sonido el video seria mudo y sin salida.
      var wantsAutoplay = video.hasAttribute('autoplay') && !reduceMotion;

      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.autoplay = false;
        video.pause();
      }

      if (soundBtn && wantsAutoplay) soundBtn.hidden = false;

      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          if (iconMuted) iconMuted.hidden = !video.muted;
          if (iconLoud) iconLoud.hidden = video.muted;
          // Quitar el sonido a un video parado no lo arranca solo.
          if (!video.muted && video.paused) video.play().catch(function () {});
        });
      }

      function syncPlayBtn() {
        if (!playBtn) return;
        playBtn.hidden = !video.paused || video.controls;
      }

      if (playBtn) {
        playBtn.addEventListener('click', function () {
          video.play().catch(function () {});
        });
      }

      video.addEventListener('play', syncPlayBtn);
      video.addEventListener('pause', syncPlayBtn);
      syncPlayBtn();

      /* Pausa fuera de pantalla. Un bucle que sigue decodificando cuando ya
         nadie lo mira se come bateria y datos, y el 93,4% del trafico es movil.
         Solo se reanuda lo que el propio navegador habia arrancado: si el
         cliente le dio a pausa, se queda pausado. */
      if (!('IntersectionObserver' in window)) return;

      var pausedByUs = false;

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (pausedByUs) {
                pausedByUs = false;
                video.play().catch(function () {});
              }
            } else if (!video.paused) {
              pausedByUs = true;
              video.pause();
            }
          });
        },
        { threshold: 0.15 }
      ).observe(video);
    }

    function initAll(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      context.querySelectorAll('[data-rvf-root]').forEach(initRoot);
      if (context !== document && context.matches && context.matches('[data-rvf-root]')) {
        initRoot(context);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    // El theme editor reinyecta la seccion entera al tocar cualquier setting.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["roro-video-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Un vídeo que arranca solo es movimiento: con reduced-motion se para y se
    // le devuelven los controles para que se pueda ver a voluntad.
    function respectMotionPreference(scope) {
      if (!window.matchMedia) return;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-rvs-video]').forEach(function (video) {
        if (!video.autoplay) return;
        video.autoplay = false;
        video.controls = true;
        video.pause();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        respectMotionPreference(document);
      });
    } else {
      respectMotionPreference(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      respectMotionPreference(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
